import { useState, useEffect } from 'react';
import './LoadingAnimation.css';

const LoadingAnimation = () => {
  const [loadingMessage, setLoadingMessage] = useState('Initializing analysis...');
  
  const messages = [
    'Found impacted stocks...',
    'Analyzing market impact...',
    'Evaluating correlation...',
    'Checking secondary effects...',
    'Modeling revenue impact...',
    'Calculating risk metrics...',
    'Processing market sentiment...',
    'Analyzing historical patterns...',
    'Computing confidence intervals...',
    'Generating final analysis...',
    'Preparing detailed report...',
    'Almost complete...'
  ];
  
  useEffect(() => {
    let currentIndex = 0;
    
    const interval = setInterval(() => {
      currentIndex = (currentIndex + 1) % messages.length;
      setLoadingMessage(messages[currentIndex]);
    }, 7000);
    
    return () => clearInterval(interval);
  }, []);
  
  return (
    <div className="loading-overlay">
      <div className="loading-container">
        <div className="spinner"></div>
        <div className="loading-message">{loadingMessage}</div>
        <div className="loading-submessage">
          Please wait while we analyze your scenario...
        </div>
      </div>
    </div>
  );
};

export default LoadingAnimation;